import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ColorPicker } from 'primereact/colorpicker';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { trustimg3 } from '@/utils/imagepath';
import { postData } from '@/services/api.service';
import { toast } from 'react-toastify';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { fetchCroppedImage } from '@/utils/constants';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

const BusinessPersonalEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabData, setActiveTabData] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [bannerImageChange, setBannerImageChange] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [backgroundImages, setBackgroundImages] = useState<string[]>([]);

  const images: Array<string> = [
    trustimg3,
    trustimg3,
    trustimg3,
    trustimg3,
    trustimg3,
    trustimg3,
    trustimg3,
  ];

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    setCropImageHeight('150');
    setCropImageWidth('150');
    setSelectedCropImage(image);
    setShowCropModal(true);
  };
  const updateImageSectionBanner = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    // setBannerImageChange(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    // if (imageLink != false && bannerImageChange == false) {
    //   handleImageChange(imageLink, activeTab);
    // }
    if (imageLink != false) {
      handleBannerImageChange(imageLink);
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_4.home.section_6.card_section.collection,
    ];

    let newCard = {
      collection_list: '',
      id: activeTab + 2,
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_6: {
            ...prevJsonData.theme_4.home.section_6,
            card_section: {
              // ...prevJsonData.theme_4.home.section_6?.card_section,

              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  // const removeCollection = (index: any) => {
  //   let updatedCollection: any = [
  //     ...editData.home.section_6.card_section.collection,
  //   ];
  //   updatedCollection.splice(index, 1);
  //   setActiveTab(activeTab - 1);

  //   setEditData((prevJsonData: any) => ({
  //     ...prevJsonData,
  //     theme_4: {
  //       ...prevJsonData.theme_4,
  //       home: {
  //         ...prevJsonData.theme_4.home,
  //         section_6: {
  //           ...prevJsonData.theme_4.home.section_6,
  //           card_section: {
  //             // ...prevJsonData.theme_4.home.section_6?.card_section,

  //             collection: updatedCollection,
  //           },
  //         },
  //       },
  //     },
  //   }));
  // };

  const addCollectiondata = () => {
    let updatedCollectiondata: any = [
      ...editData.theme_4.home.section_6.card_section_two.collection,
    ];

    let newCards = {
      collection_list: '',
      id: activeTabData + 2,
    };
    updatedCollectiondata.splice(activeTabData + 1, 0, newCards);
    setActiveTabData(activeTabData + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_6: {
            ...prevJsonData.theme_4.home.section_6,
            card_section_two: {
              ...prevJsonData.theme_4.home.section_6?.card_section_two,

              collection: updatedCollectiondata,
            },
          },
        },
      },
    }));
  };
  const removeCollectiondata = (index: any, card_section_name: any) => {
    let updatedCollectiondata: any = [
      ...editData.theme_4.home.section_6[card_section_name].collection,
    ];
    updatedCollectiondata.splice(index, 1);
    if (card_section_name == 'card_section') {
      setActiveTab(activeTab - 1);
    } else {
      setActiveTabData(activeTabData - 1);
    }

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_6: {
            ...prevJsonData.theme_4.home.section_6,
            [card_section_name]: {
              ...prevJsonData.theme_4.home.section_6[card_section_name],

              collection: updatedCollectiondata,
            },
          },
        },
      },
    }));
  };

  const handleChange = (e: any, index?: any, section?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_4.home.section_6.card_section.collection,
    ];
    let updatedCollectiondata: any = [
      ...editData.theme_4.home.section_6.card_section_two.collection,
    ];
    if (index != undefined) {
      if (section == 'card_section') {
        updatedCollection = [
          ...editData.theme_4.home.section_6[section].collection,
        ];
        updatedCollection[index] = {
          ...updatedCollection[index],
          [name]: value,
        };
      }
      if (section == 'card_section_two') {
        updatedCollectiondata = [
          ...editData.theme_4.home.section_6[section].collection,
        ];
        updatedCollectiondata[index] = {
          ...updatedCollectiondata[index],
          [name]: value,
        };
      }
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_6: {
            ...prevJsonData.theme_4.home.section_6,
            [name]: value,
            card_section: {
              collection: updatedCollection,
            },
            card_section_two: {
              collection: updatedCollectiondata,
            },
          },
        },
      },
    }));
  };

  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_4.home.section_6.card_section.collection,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      icon: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_6: {
            ...prevJsonData.theme_4.home.section_6,
            card_section: {
              ...prevJsonData.theme_4.home.section_6.card_section,
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const handleBannerImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_6: {
            ...prevJsonData.theme_4.home.section_6,
            first_card_image: image,
          },
        },
      },
    }));
  };

  // Auto-generate prompt based on business personal section context for Background
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_4?.home?.section_6?.title || '';
    const paragraph = editData?.theme_4?.home?.section_6?.paragraph || '';
    const subTitle = editData?.theme_4?.home?.section_6?.sub_title || '';
    
    let contextPrompt = 'modern professional image for business personal section background';
    
    if (title || paragraph || subTitle) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for business personal section background, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI background image save
  const handleAIImageSave = (imageUrl: string) => {
    handleBannerImageChange(imageUrl);
    setBackgroundImages(prevImages => [...prevImages, imageUrl]);
    
    const templateKey = template ? `template${template}` : 'template4';
    const currentTemplate = templateImages[templateKey] || {};
    const currentImages = currentTemplate.image || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        image: [...currentImages, { url: imageUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template4';
      const currentTemplate = templateImages[templateKey];
      const imageImgs = currentTemplate?.image || [];
      
      // Helper function to load image dimensions
      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve({ url, width: img.width, height: img.height });
          };
          img.onerror = () => {
            resolve(null);
          };
          img.src = url;
        });
      };

      // Load and filter background images (square from image array)
      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const filterBackgroundImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setBackgroundImages(squareImages);
        };

        filterBackgroundImages();
      } else {
        setBackgroundImages([]);
      }
    } else {
      setBackgroundImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section six Theme Four Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_4?.home?.section_6?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Description
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="website_description"
                        placeholder="Describe what you want in your description. Example: 'Write about business and personal services'"
                        context="This is for the business personal section description"
                      />
                    </div>
                    <textarea
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_4?.home?.section_6?.paragraph}
                      onChange={handleChange}
                      maxLength={1200}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_4?.home?.section_6?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_4?.home?.section_6?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_4?.home?.section_6?.h3color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_4?.home?.section_6?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_4?.home?.section_6?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_4?.home?.section_6?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-1">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="form-label">
                          First card background
                        </label>
                        <div className="img-bg active">
                          <img
                            src={
                              editData?.theme_4?.home?.section_6
                                ?.first_card_image
                            }
                            alt="Hero Image"
                          />
                        </div>
                        <div className="img-options">
                          <div className="row">
                            <div className="col-md-12">
                              {backgroundImages.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: {
                                      slidesPerView: 1,
                                    },
                                    768: {
                                      slidesPerView: 4,
                                    },
                                    1024: {
                                      slidesPerView: 6,
                                    },
                                  }}
                                  className="homejson-slider"
                                >
                                  {backgroundImages.map((imageUrl: string, idx: number) => {
                                    return (
                                      <SwiperSlide key={idx}>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleBannerImageChange(imageUrl)
                                          }
                                        >
                                          <img
                                            src={imageUrl}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Background Images Available</h6>
                                    <p className="text-muted small mb-3">
                                      Generate AI images or upload your own to see them here
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* AI Image Generator */}
              <AIImageGenerator
                generateAutoPrompt={generateAutoPromptBanner}
                onSave={handleAIImageSave}
                imageType="image"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />

              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Upload Image</label>
                    <input
                      type="file"
                      accept="image/png, image/jpeg"
                      className="form-control"
                      name="image"
                      onChange={updateImageSectionBanner}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Sub Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_title"
                      value={editData?.theme_4?.home?.section_6?.sub_title}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_4?.home?.section_6?.card_section?.collection.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollectiondata(index, 'card_section');
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_4?.home?.section_6?.card_section?.collection.map(
                  (card: any, index: any) => {
                    return (
                      <div
                        key={index}
                        className={`tab-pane fade ${
                          activeTab === index ? 'show active' : ''
                        }`}
                      >
                        <div className="mb-3">
                          <label className="form-label">
                            Title<small>(max 250 char)</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="collection_list"
                            value={card.collection_list}
                            onChange={(e) =>
                              handleChange(e, index, 'card_section')
                            }
                            maxLength={250}
                          />
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>

            <div className="edit-section">
              <div className="mb-3">
                <label className="form-label">Sub Title Two</label>
                <input
                  type="text"
                  className="form-control"
                  name="sub_title_two"
                  value={editData?.theme_4?.home?.section_6?.sub_title_two}
                  onChange={handleChange}
                  maxLength={1200}
                />
              </div>
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_4?.home?.section_6?.card_section_two?.collection.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTabData === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTabData(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollectiondata(index, 'card_section_two');
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_4?.home?.section_6?.card_section_two?.collection.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTabData === index ? 'show active' : ''
                      }`}
                    >
                      <div className="mb-3">
                        <label className="form-label">
                          List<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_list"
                          value={card.collection_list}
                          onChange={(e) =>
                            handleChange(e, index, 'card_section_two')
                          }
                          maxLength={250}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollectiondata();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default BusinessPersonalEditModal;
